// extracted by mini-css-extract-plugin
export default {"container":"firewalls_container__K7ZFP","section":"firewalls_section__jLN6f"};